import React, { Component, useState, useEffect } from 'react';
import { Helmet } from "react-helmet";
import renderPenname from './utils/renderPenname';
import {
  isBrowser,
} from "react-device-detect";
class NormalEditorTypePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isSticky: false
    }
    this.headerRef2 = React.createRef()
    this.headerRef = React.createRef()
  }
  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    // important
    window.addEventListener('scroll', this.handleScroll);
  }
  handleScroll = (event) => {
    if (this.headerRef.current) {
      this.setState({
        isSticky: (this.headerRef.current.getBoundingClientRect().top <= 0)
      })
    }
  };
  generateCategory = category => {
    category = _.unionBy(category, "_id");
    let stringBuilder = [];
    category.forEach((cat, index) => {
      if (index === 0) {
        let stringBuilder1 = (
          <a
            key={`item-category${cat._id}${index}`}
            className="text-uppercase ff-medium fz16 text-hover-red"
            href={`/posts?category=${cat._id}&page=1&limit=10`}
          >
              {cat.name}
          </a>
        );
        stringBuilder.push(stringBuilder1);
      }
    });
    return stringBuilder;
  };
  generateCategoryMobile = (category, postContent) => {
    category = _.unionBy(category, "_id");
    let stringBuilder = [];
    category.forEach((cat, index) => {
      if (index === 0) {
        let stringBuilder1 = (
          <div className="d-block align-items-center" key={`item-category${cat._id}${index}`}>
              
                <React.Fragment key={`bc-article`}>
                {cat &&
                <div className="pb-1 overflow-hidden mt-2">
                  <div className="white-space-nowrap overflow-x-scroll scrollbar-none">
                    <h3 className="jsx-754319937 d-inline-block">
                      <a href={`/posts?category=${cat._id}&page=1&limit=10`} prefetch="false" className="jsx-754319937 text-uppercase fw-600 fz14 d-flex text-grey-9">
                        {/* <img src="https://beta-m.saostar.vn/static/fonts/ss/tvshow.svg" className="jsx-754319937 w--16 h--16 mr-1" /> */}
                        <p style={{alignSelf : "center"}}>{cat.name}</p>
                      </a>
                    </h3>
                  </div>
                </div>
                }
                {/* {postContent.publishedAt &&
                  <div className="d-flex">
                    <time dateTime="2021-06-30T15:15:00.176+07:00" className="time-ago text-grey fz12 mt--2-5">
                        <span className="time undefined">{this.timeDifference(postContent.publishedAt)}</span>
                        {postContent.posttype && postContent.posttype.type_code && postContent.posttype.type_code != "ready" && 
                          <span className='fw-bold'> - Đã hạ</span>
                        }
                    </time>
                  </div>
                } */}
                </React.Fragment>
              
          </div>
        );
        stringBuilder.push(stringBuilder1);
      }
    });
    return stringBuilder;
  };

  timeDifference = (publishedAt) => {

    const current = new Date();
    const previous = new Date(publishedAt);
    const minute = previous.getMinutes() < 10 ? '0' + previous.getMinutes() : previous.getMinutes();
    const hour = previous.getHours();
    const date = previous.getDate() < 10 ? '0' + previous.getDate() : previous.getDate();
    const month = (previous.getMonth() + 1) < 10 ? '0' + (previous.getMonth() + 1) : (previous.getMonth() + 1);
    const year = previous.getFullYear();

    return `${date}/${month}/${year} - ${hour}:${minute} GMT+7`;
  }

  generateTags = tags => {
    tags = _.unionBy(tags, "_id");
    let stringBuilder = [];
    tags.forEach((tag, index) => {
      let stringBuilder1 = (
      <h3 className="d-inline-block" key={tag._id}>
        <a
          key={`item-tag${tag._id}${index}`}
          className="tag-tab bg-grey-14 mb-1 mr-1"
          href=""
        >
          {tag.label}
        </a>
      </h3>
      );
      stringBuilder.push(stringBuilder1);
    });
    return stringBuilder;
  };


  render() {
    let {
      postContent: {
        title,
        description,
        content,
        categories,
        contentpenname,
        tags
      },
      isMobile,
      postContent
    } = this.props;
    const {
      isSticky
    } = this.state;
    if(isMobile || !isBrowser){
      return (
        <div id="previewpage-saostar-mobile" className="previewpage-saostar-mobile" onScroll={this.handleScroll}>
        <Helmet>
          <link
            rel="stylesheet"
            href={process.env.PUBLIC_URL + "/assets/css/style-mobile.css?v=1.4"}
          />
          <link rel="preconnect" href="https://fonts.googleapis.com" />
          <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin />
          <link href="https://fonts.googleapis.com/css2?family=Questrial&display=swap" rel="stylesheet" />
          <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0, user-scalable=yes"/>
        </Helmet>
        <div className="previewpage-saostar layout" style={{"height":"auto", "fontFamily": "Questrial"}}>
          <div id="overlay" className="overlay "></div>
          {/* <div id="mobi-top" className="ads bg-grey-6 text-center">
            <img src="http://via.placeholder.com/375x375" />
          </div> */}
          {/* <header ref={this.headerRef} className={"d-flex position-relative justify-content-between align-items-center border-bottom py-2 pl-1 pr-3 z--50 bg-white "}>
            <a className="logo" data-on="click" data-event-category="Header - Logo" data-event-action="click" href="/" prefetch="false">
              <img className="logo-saostar2 logo-red" src="https://ss-statics-m.saostar.vn/static/images/logo-saostar-tapchi.svg" alt="saostar.vn" />
              <img className="logo-saostar logo-white" width="176px" height="43px" src="https://ss-statics-m.saostar.vn/static/images/logo-white-saostar-tapchi.svg" alt="saostar.vn" />
            </a>
            <div className='d-flex align-items-center justify-content-between'>
              <div className="d-inline-block cursor-pointer">
                <span className="ssf-search fz26 text-red-5 "></span>
              </div>
              <button className="ham-menu ml-3 mr-1 " id="ham-4" href="#"><span></span></button>
            </div>
          </header> */}
          <div id="articlepage" className="main-layout px-2 py-3 bg-white" style={{"fontFamily": "Questrial"}}>            
              <div className="bg-white">
                  {this.generateCategoryMobile(categories, postContent)}
              </div>
              <article style={{"height": "auto"}}>
                <h1 className="art-title mt-2">
                  {title || "Chưa có tiêu đề"}
                </h1>
                <div className="mt-4 d-flex align-items-center justify-content-between">
                  <div>
                    <span className="fz14 fw-bold" style={{"color": "#5D6470"}}>
                      {renderPenname(contentpenname)}
                    </span>
                    {postContent.publishedAt &&
                      <div className="d-flex mt-1">
                        <time dateTime="2021-06-30T15:15:00.176+07:00" className="time-ago text-grey fz13 mt--2-5">
                            <span className="time undefined">{this.timeDifference(postContent.publishedAt)}</span>
                            {postContent.posttype && postContent.posttype.type_code && postContent.posttype.type_code != "ready" && 
                              <span className='fw-bold'> - Đã hạ</span>
                            }
                        </time>
                      </div>
                    }
                  </div>                  
                </div>
                {/* <div className="art-thumb mt-4">
                {postContent.img_hor &&
                  <img src={postContent.img_hor} width="400" height="250"/>
                }

                </div> */}
                <h2 className="art-sapo mt-4">
                  {description}
                </h2>
                <div id="mobi-sapo" className="ads mt-2 text-center">
                </div>
                {content ? (
                    <div
                      itemProp="articleBody"
                      className="art-content"
                      dangerouslySetInnerHTML={{ __html: content }}
                    />
                  ) : (
                      <center>
                        <em>Add your custom block in the editor</em>
                      </center>
                    )}

                <div className="mt-4 text-right d-flex justify-content-flex-end mx-auto w-95">
                  {postContent.contentpenname &&
                    <div className="fz16 fw-bold leading-20px"><p className="fw-normal fz12px leading-20px">Bài viết</p><p className="leading-20px">{renderPenname(postContent.contentpenname)}</p></div>
                  }
                  {postContent.contentdesigner &&
                    <div className="fz16 fw-bold ml-4 leading-20px"><p className="fw-normal fz12px leading-20px">Thiết kế</p><p className="leading-20px">{postContent.contentdesigner.label}</p></div>
                  }
                  {postContent.contentphoto &&
                    <div className="fz16 fw-bold ml-4 leading-20px"><p className="fw-normal fz12px leading-20px">Photo</p><p className="leading-20px">{postContent.contentphoto.label}</p></div>
                  }
                  {postContent.contentvideo &&
                    <div className="fz16 fw-bold ml-4 leading-20px"><p className="fw-normal fz12px leading-20px">Video</p><p className="leading-20px">{postContent.contentvideo.label}</p></div>
                  }
                </div>
                <div className="mt-1 text-right">
                  {postContent.contentsource &&
                    <span className="fz16 fw-bold">Theo {postContent.contentsource.label}</span>
                  }
                </div>
                <div className="art-tag mt-6">
                    {postContent.contentsource && postContent.sourcename && 
                      <>
                      <p className="fz12 ff-regular text-grey-7">Nguồn bài viết: <span className="fz12 fw-bold text-black-6">{postContent.contentsource.label}</span></p>
                      <p className="fz12 ff-regular text-grey-7">Link nguồn: <span className="fz12 fw-bold text-black-6">{postContent.sourcename}</span></p>
                      </>
                    }
                  </div>
                <div className="art-tag mt-6">
                  <span className="ssf-tag mr-2 text-grey-9 fz20px t--7 position-relative"></span>
                  {postContent.tags && postContent.tags.map((tag, idx) =>
                    <h3 key={tag._id} className="d-inline-block"><a key={`art-tag-${idx}`} href={`/tag/${tag.slug}/`} prefetch="false" className="tag-tab mb-1 mr-1">{tag.label}</a></h3>
                  )}
                </div>
                <div className="d-flex my-4 w-100"><div className="w-50 justify-content-center text-grey-13 px-2 py--10 rounded--4 mr-2 fz12 cursor-pointer d-flex align-items-center border-grey-11"><span className="ssf-copylink mr-1"></span><span className="label-copylink"></span></div><div className="text-grey-13 px-2 py--10 w-50 justify-content-center rounded--4 fz12 cursor-pointer d-flex align-items-center border-grey-11"><span className="ssf-facebook mr-1"></span><span>Chia sẻ</span></div></div>
              </article>
            </div>
          </div>
        </div>
      );
    }
    return (
      <div className="previewpage-saostar">
        <Helmet>
          <link
            rel="stylesheet"
            href={process.env.PUBLIC_URL + "/assets/css/style.css"}
          />
        </Helmet>
        <div className="bg-overlay" id="bg-overlay"></div>

        {/* <header ref={this.headerRef2} className="">
          <div className="default-page-width ma d-flex justify-content-between align-items-center py-2 overflow-hidden h--80" style={{"height" : "62px"}}>
              <a data-on="click" data-event-category="Header - Logo" data-event-action="click" href="/"><img className="logo-saostar cursor-pointer pt-1" src="/assets/images/logo-saostar-tapchi.svg" alt="saostar.vn" /></a>
              <div className="list-icon">
                  <a data-on="click" data-event-category="Menu" data-event-action="Báo giá" download prefetch="false" className="d-inline-block pr-4 text-hover-red justify-content-center align-items-center"><div className="d-flex"><div className="align-sub w--25 icon-hover" alt="liên hệ" style={{"height" : "25px", "width" : "25px", "marginRight": "5px","backgroundImage": "url('/assets/fonts/ss/ico_contact_new.svg')"} } ></div><div className="icon-label fw-bold"> LIÊN HỆ</div></div></a>
                  <div className="d-inline-block cursor-pointer">
                    <span className="ssf-search fz26 text-hover-red"></span>
                    
                  </div>
              </div>
          </div>
        </header>

        <header className={" t--0 z--100"  + (isSticky ? '' : '')} ref={this.headerRef}  style={{"height" : "53px"}}>
          <div className="rounded-pill px-5 bg-red category-menu default-page-width ma d-flex justify-content-between align-items-center">
            <a className="logo-menu" data-on="click" data-event-category="Header - Logo" data-event-action="click" href="/">
              <img className="logo-saostar cursor-pointer pt-1" src="/assets/images/logo-saostar-tapchi.svg" alt="saostar.vn" />
            </a>
            <div className="category-in-header"><a data-on="click" data-event-category="Menu" data-event-action="NGƯỜI MẪU & HOA HẬU" href="https://www.saostar.vn/nguoi-mau-hoa-hau/" prefetch="false" className=" cate-name text-white text-hover-white text-uppercase fz12 ff-bold">NGƯỜI MẪU & HOA HẬU</a></div>
            <div className="category-in-header"><a data-on="click" data-event-category="Menu" data-event-action="FASHION" href="https://www.saostar.vn/thoi-trang/" prefetch="false" className=" cate-name text-white text-hover-white text-uppercase fz12 ff-bold">FASHION</a></div>
            <div className="category-in-header"><a data-on="click" data-event-category="Menu" data-event-action="ĐẸP 360" href="https://www.saostar.vn/dep-360/" prefetch="false" className=" cate-name text-white text-hover-white text-uppercase fz12 ff-bold">ĐẸP 360</a></div>
            <div className="category-in-header"><a data-on="click" data-event-category="Menu" data-event-action="GIẢI TRÍ" href="https://www.saostar.vn/giai-tri/" prefetch="false" className=" cate-name text-white text-hover-white text-uppercase fz12 ff-bold">GIẢI TRÍ</a></div>
            <div className="category-in-header"><a data-on="click" data-event-category="Menu" data-event-action="SAO & ĐỜI SỐNG" href="https://www.saostar.vn/sao-va-doi-song/" prefetch="false" className=" cate-name text-white text-hover-white text-uppercase fz12 ff-bold">SAO & ĐỜI SỐNG</a></div>
            <div className="category-in-header"><a data-on="click" data-event-category="Menu" data-event-action="ÂM NHẠC" href="https://www.saostar.vn/am-nhac/" prefetch="false" className=" cate-name text-white text-hover-white text-uppercase fz12 ff-bold">ÂM NHẠC</a></div>
            <div className="category-in-header"><a data-on="click" data-event-category="Menu" data-event-action="PHIM ẢNH" href="https://www.saostar.vn/dien-anh/" prefetch="false" className="cate-name text-white text-hover-white text-uppercase fz12 ff-bold">PHIM ẢNH</a></div>
            <div className="category-in-header"><a data-on="click" data-event-category="Menu" data-event-action="SỐNG KHỎE" href="https://www.saostar.vn/song-khoe/" prefetch="false" className=" cate-name text-white text-hover-white text-uppercase fz12 ff-bold">SỐNG KHỎE</a></div>
            <div className="category-in-header"><a data-on="click" data-event-category="Menu" data-event-action="SẮC MÀU CUỘC SỐNG" href="https://www.saostar.vn/sac-mau-cuoc-song/" prefetch="false" className=" cate-name text-white text-hover-white text-uppercase fz12 ff-bold">SẮC MÀU CUỘC SỐNG</a></div>
            <span className="more icon cursor-pointer fz28 position-relative category-in-header ssf-list"></span>
          </div>

        </header> */}

        <div id="articlepage" className="main-layout bg-white ">
          
          <div className="w1000 ma mt-8">
              <div className="d-flex align-items-center justify-content-between w-offset-300 px--20">
                <div className="breadcrumb-article">
                  {this.generateCategory(categories)}
                  <span className="d-flex justify-content-center">                    
                    {postContent.publishedAt &&
                      <time dateTime="2021-06-30T15:15:00.176+07:00" className="time-ago text-grey-11 fz14">
                        <span className="time undefined">Đăng lúc {this.timeDifference(postContent.publishedAt)}</span>
                        {postContent.posttype && postContent.posttype.type_code && postContent.posttype.type_code != "ready" && 
                          <span className='fw-bold'> - Đã hạ</span>
                        }
                      </time>
                    }                   
                  </span>
                </div>
                <div style={{'display': 'flex', 'alignItems': 'center', 'height': '32px', 'backgroundColor': '#e8e8e8', 'borderRadius': '999px', 'padding': '6px 16px 5px 16px'}}>
                  <img src="https://statics-pc.saostar.vn/static/images/googleNews.png?v=2.51" width={92} height={15}/>
                </div>
              </div>
              <article className="mb-5 mt40 w1000 ma m-w-90 px--20">

              <div className="d-flex justify-content-between mt-4">
                
                <div className="d-flex justify-content-between">
                <div className="w-offset-300" style={{"marginRight": "30px"}}>
                  <h1 className="art-title mt-2 mb-4">{title || "Chưa có tiêu đề"}</h1>
                  {contentpenname && (
                    <div className="d-flex justify-content-between align-items-center">
                      <span className="text-grey-7">
                        <span className="fz16 ff-bold text-red-4 text-uppercase">{renderPenname(contentpenname)}</span>
                      </span>                      
                    </div>
                  )}
                  <h2 className="art-sapo ff-medium mt-4">{description}</h2>

                  {content ? (
                    <div
                      itemProp="articleBody"
                      className="art-content"
                      dangerouslySetInnerHTML={{ __html: content }}
                    />
                  ) : (
                      <center>
                        <em>Add your custom block in the editor</em>
                      </center>
                    )}
                  <div className="d-flex justify-content-between align-items-center">
                    <img src="/assets/images/btncopylink.png" className="w160 mt-7"/>
                    <div className="mt-2 d-flex justify-content-flex-end mb-7">
                      {postContent.contentpenname &&
                        <div className="text-right">
                          <p className="fz14 ff-regular text-grey-7">BÀI VIẾT</p>
                          <p className="fz16 fw-bold mt-1">{renderPenname(postContent.contentpenname)}</p>
                        </div>
                      }
                      {postContent.contentphoto &&
                        <div className="text-right">
                          <p className="fz14 ff-regular text-grey-7">PHOTO</p>
                          <p className="fz16 fw-bold mt-1 ml-4">{postContent.contentphoto.label}</p>
                        </div>
                      }
                      {postContent.contentdesigner &&
                        <div className="text-right">
                          <p className="fz14 ff-regular text-grey-7">THIẾT KẾ</p>
                          <p className="fz16 fw-bold mt-1 ml-4">{postContent.contentdesigner.label}</p>
                        </div>
                      }
                      {postContent.contentvideo &&
                        <div className="text-right">
                          <p className="fz14 ff-regular text-grey-7">VIDEO</p>
                          <p className="fz16 fw-bold mt-1 ml-4">{postContent.contentvideo.label}</p>
                        </div>
                      }
                      {postContent.contentsource &&
                        <div className="text-right">
                          <p className="fz14 ff-regular text-grey-7">THEO</p>
                          <p className="fz16 fw-bold mt-1 ml-4">{postContent.contentsource.label}</p>
                        </div>
                      }
                    </div>
                  </div>
                  <div className="art-tag mt---50">
                    {postContent.contentsource && postContent.sourcename && 
                      <>
                      <p className="fz12 ff-regular text-grey-7">Nguồn bài viết: <span className="fz12 fw-bold text-black-6">{postContent.contentsource.label}</span></p>
                      <p className="fz12 ff-regular text-grey-7">Link nguồn: <span className="fz12 fw-bold text-black-6">{postContent.sourcename}</span></p>
                      </>
                    }
                  </div>
                  
                    <div className="art-tag mt---50">
                      <span className="fz18 pt-1 align-sub ff-regular text-uppercase text-grey-7 mr-2 ssf-tag"></span>
                        {this.generateTags(tags)}
                    </div>
                  
                 
                  
                  </div>
                  <div className="w--300" style={{"flexShrink": "0"}}>
                      <div className='w-full h--600 d-flex justify-content-center align-items-center fz-15 text-center position-sticky' style={{"border": "1px solid #d7d7d7", "top": '0'}}>
                        Ads
                      </div>
                  </div>

                  </div>
                 
                  
                 
                  {/* <div className="w--300">

                      <div id="pc-med" className="t--70 ads mb-4">
                          <img src="https://via.placeholder.com/600x600/FFFFFF" className="" />
                      </div>
                      <img src="https://via.placeholder.com/300x600/FFFFFF" className="ads t--70 position-sticky" />
                  </div> */}
                  </div>

            </article>
            
            
          </div>
          
        </div>
        

        
      </div>
    );
  }
}


NormalEditorTypePage.propTypes = {

};


export default NormalEditorTypePage;
